
import { Vue, Component } from 'vue-property-decorator';
import editor from './editor';
@Component({
  mixins: [editor],
})
export default class StringInlineEditor extends Vue {}
